var fails = require('../internals/fails');

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});



//////////////////
// WEBPACK FOOTER
// ./~/react-stickynode/~/core-js/internals/correct-prototype-getter.js
// module id = 430
// module chunks = 0